// extracted by mini-css-extract-plugin
export var radioCharlieLabel = "pages-account-__AddMobileCard-module___radioCharlieLabel";
export var radioCharlieOption = "pages-account-__AddMobileCard-module___radioCharlieOption";
export var radioCharlieType = "pages-account-__AddMobileCard-module___radioCharlieType";